import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal } from "antd";
import { assignMessage, convertRoundNumber, errorMessage, successMessage } from '../../../utils/helpers'
import { ADMIN } from '../../../utils/apis'
import axios from "axios";
import { currencySign } from "../../../utils/constants";

const ServiceFeeForCompetition = (props) => {
    const { user, language, selectedLanguage } = props
    const [visible, setVisible] = useState(false)
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [cashbackServiceFee, setcashbackServiceFee] = useState(null)

    const getcashbackServiceFee = () => {
        axios.get(ADMIN?.GET_COMPETITION_SUB_SERVICE_FEE)
            .then((res) => {
                const { data } = res
                setcashbackServiceFee(data?.data?.[0] || [])
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }


    const onFinish = (values) => {
        values.adminId = user?._id
        cashbackServiceFee?._id && (values._id = cashbackServiceFee?._id)
        axios.post(cashbackServiceFee?._id ? ADMIN?.EDIT_COMPETITION_SUB_SERVICE_FEE : ADMIN?.ADD_COMPETITION_SUB_SERVICE_FEE, values)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    getcashbackServiceFee()
                }
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }

    useEffect(() => {
        getcashbackServiceFee()
    }, [])

    const handleOk = () => {
        setVisible(false)
    }


    return (
        <>
            <div className="reward-point-box">
                <p className="p-none-margin-bolder-p">{selectedLanguage?.txt_Player_need_to_pay_Competition_subscription_service_fee_that_you_set_here}</p>
                <p className="p-none-margin-bolder-p">
                    {selectedLanguage?.txt_Player_want_to_pay}
                    ( {cashbackServiceFee?.money ? `${currencySign} ${convertRoundNumber(cashbackServiceFee?.money)}` : '---'} )
                    {selectedLanguage?.txt_for_subscription_of_competition_as_servicefee}</p>
                <div style={{ marginTop: '20px' }} className='button-div-flex-end'>
                    <Button
                        type="primary"
                        onClick={() => { setVisible(true) }}
                    > {selectedLanguage?.txt_Update_competition_service_fee}</Button>
                </div>
            </div>



            {/* --------Modal----- */}
            <Modal
                open={visible}
                onOk={handleOk}
                onCancel={handleOk}
                className='pop-info-modal'
                footer={null}>
                <div style={{ marginTop: '10px' }}>
                    <p className='p-question'>{selectedLanguage?.text_UpdateCashbackServiecFee}</p>
                    <div style={{ display: 'flex', flexDirection: 'column' }} className='form-div-in-modal'>
                        <Form
                            name='form'
                            form={form}
                            onFinish={onFinish}
                            layout={'vertical'}
                        >
                            <div className='form-two-input-flex-inner-input newInpuHeightFull' style={{ width: '100%' }}>
                                <Form.Item
                                    name='money'
                                    initialValue={cashbackServiceFee?.money}
                                    hasFeedback
                                    label={<p className='p-admin-title-text'>{selectedLanguage?.text_CashbackServiecFee}</p>}
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.error_CashbackServiecFee
                                        }
                                    ]}
                                >
                                    <Input
                                        // Number
                                        step={0.01}   
                                        precision={2}
                                        type='number'
                                        style={{ width: '100%' }}
                                        className='form-input-new-design-big-slam'
                                        prefix={<p style={{ color: 'white', margin: '0px' }}>{currencySign}</p>}
                                        placeholder={selectedLanguage?.place_CashbackServiecFee}
                                    />
                                </Form.Item>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', height: '40px', paddingRight: '5px' }}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType='submit'
                                        loading={loading}
                                    >
                                        {cashbackServiceFee?.money ? selectedLanguage?.text_UpdatePointSetting : selectedLanguage?.text_AddPointSetting}
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </div >
            </Modal >
        </>
    )
}



export default ServiceFeeForCompetition